var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialTwitterSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    rx: 10,
    fill: "#5CBBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.661 43c-3.004 0-5.804-.86-8.161-2.341 2.001.127 5.532-.178 7.729-2.238-3.304-.15-4.794-2.641-4.989-3.706.28.106 1.62.234 2.376-.064-3.801-.937-4.384-4.217-4.255-5.218.713.49 1.922.66 2.398.618-3.542-2.492-2.268-6.24-1.642-7.05 2.542 3.463 6.351 5.407 11.064 5.515a5.274 5.274 0 01-.136-1.191c0-2.941 2.417-5.325 5.4-5.325a5.42 5.42 0 013.947 1.692c1.04-.24 2.608-.802 3.374-1.287-.386 1.363-1.588 2.5-2.316 2.921-.005-.014.006.015 0 0 .64-.095 2.367-.421 3.05-.877-.338.766-1.612 2.04-2.658 2.752C43.037 35.64 36.471 43 27.661 43z",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.25,
    width: 63.5,
    height: 63.5,
    rx: 9.75,
    stroke: "#000",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })));
}
export default SvgSocialTwitterSquare;